import React from 'react';
import './Home.css';
import Product from './Product';

function Home() {
    return (
        <div className="home">
            <img
                className="home__img" 
                src="https://images-fe.ssl-images-amazon.com/images/G/35/digital/video/merch/2020/TV/BRND/BRND_MTH20_00000_GWBleedingHero_1500x600_Final_en-AU_ENG_PVD5221._CB408305644_.jpg" 
                alt=""
            />
            <div className="home__row">
                <Product 
                    id="12321341"
                    title="The Courage To Be Disliked: How to free yourself, change your life and achieve real happiness"
                    price={11.95}
                    rating={5}
                    image="https://images-na.ssl-images-amazon.com/images/I/51xwGSNX-EL._SX356_BO1,204,203,200_.jpg"
                />
                <Product 
                    id="12321342"
                    title="The Courage to be Disliked: The Japanese phenomenon that shows you how to free yourself, change your life and achieve real happiness"
                    price={10.92}
                    rating={4}
                    image="https://images-na.ssl-images-amazon.com/images/I/51+1gcgQodL._SX366_BO1,204,203,200_.jpg"
                />
            </div>
            <div className="home__row">
            <Product 
                    id="12321341"
                    title="Atomic Habits: The life-changing million copy bestseller"
                    price={30.95}
                    rating={2}
                    image="https://images-na.ssl-images-amazon.com/images/I/51cQ9ETjP2L._SX366_BO1,204,203,200_.jpg"
                />
                <Product 
                    id="12321342"
                    title="Wabi Sabi: Japanese Wisdom for a Perfectly Imperfect Life"
                    price={10.92}
                    rating={4}
                    image="https://images-na.ssl-images-amazon.com/images/I/418yEmNT3nL._SX355_BO1,204,203,200_.jpg"
                />
                <Product 
                    id="12321342"
                    title="The Book of Ichigo Ichie: The Art of Making the Most of Every Moment, the Japanese Way"
                    price={34.87}
                    rating={2}
                    image="https://images-na.ssl-images-amazon.com/images/I/41eBrjs93KL._SX348_BO1,204,203,200_.jpg"
                />
            </div>
            <div className="home__row">
            <Product 
                    id="12321349"
                    title="The Courage to be Happy: True contentment is within your power-the new Japanese phenomenon from the authors of the global bestseller, The Courage to be Disliked"
                    price={25.25}
                    rating={5}
                    image="https://images-na.ssl-images-amazon.com/images/I/41SMPwTwLPL._SX349_BO1,204,203,200_.jpg"
                />
            </div> 
        </div>
    )
}

export default Home
